import { useEffect, useState } from 'react';
import { Search, X } from 'lucide-react';

export function CommerceRegistrySearchField({
  value,
  onChange,
  placeholder,
  resultCount,
  debounceMs = 250,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  resultCount?: number;
  debounceMs?: number;
}) {
  const [draft, setDraft] = useState(value);

  useEffect(() => setDraft(value), [value]);
  useEffect(() => {
    if (draft === value) return;
    const timeout = window.setTimeout(() => onChange(draft), debounceMs);
    return () => window.clearTimeout(timeout);
  }, [debounceMs, draft, onChange, value]);

  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-border/40 bg-muted/5 px-4 py-2">
      <label className="relative min-w-[220px] flex-1 sm:max-w-sm">
        <span className="sr-only">{placeholder}</span>
        <Search className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground/60" />
        <input
          value={draft}
          onChange={event => setDraft(event.target.value)}
          placeholder={placeholder}
          maxLength={200}
          className="h-8 w-full rounded-md border border-input bg-background/50 pl-8 pr-8 text-xs text-foreground outline-none transition-colors placeholder:text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring"
        />
        {draft ? (
          <button
            type="button"
            aria-label="Clear search"
            onClick={() => {
              setDraft('');
              onChange('');
            }}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground/50 hover:text-foreground"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        ) : null}
      </label>
      {typeof resultCount === 'number' ? (
        <span className="text-[11px] font-medium tabular-nums text-muted-foreground">
          {resultCount} result{resultCount === 1 ? '' : 's'}
        </span>
      ) : null}
    </div>
  );
}
